import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import ContentContainer from "../../components/_common/_containers/ContentContainer/index"
import FullWidthContainer from "../../components/_common/_containers/FullWidthContainer/FullWidthContainer"
import NRTAppContainer from "../../components/_common/_containers/AppContainer"
import NRTTabContainer from "../../components/_common/TabContainer"
import TabBasicConfig from "./_partials/TabBasicConfig"
import {Helmet} from 'react-helmet'
import Base64 from 'base-64'
import QueryString from 'query-string'
import Endpoints from '../../config/endpoints'
import Request from '../../helpers/request'
import MCEadContentCard from "../../components/_ead/ContentCard"
import MCRequests from "../../requests/mc-requests"
import {setPrimaryColor, setSecondaryColor} from "../../helpers/theme"
import TabSectionConfig from "./_partials/TabSectionsConfig"
import TabBannersConfig from "./_partials/TabBannersConfig"


const SIMULATE_SAVE_CONFIG_ERROR = false


class AdminPage extends Component {


    state = {
        activeTabId: 'configbasica',
        systemConfig: null,
        systemConfigParameterValue: null,
        formValid: true,

    }


    static getDerivedStateFromProps(nextProps) {
        return {
            systemConfig: nextProps.context.systemConfig,
            systemConfigParameterValue: nextProps.context.systemConfigParameterValue,


        }
    }


    async componentDidMount() {
        window.scrollTo(0, 0)

        this.setState({
            title: _.get(this.props.context, 'systemConfigParameterValue.title', '')
        })

        this.checkUserAdmin()

    }


    handleTabChange = (tab) => {
        if (this.state.formValid) {
            this.setState(prevState => ({
                ...prevState,
                activeTabId: tab,
            }))
        }

    }


    configChanged = _.debounce((changes) => {

        if ((changes.title + '').trim().length < 3) {
            this.setState({formValid: false})
            return
        }

        this.setState({formValid: true})

        const systemConfig = {
            ...this.state.systemConfig,

            // parameterType: this.state.systemConfig.parameterValueType,
            parameterGroup: "Empresa",
            parameterValue: JSON.stringify({
                ...this.state.systemConfigParameterValue,
                ...changes
            })

        }

        // delete systemConfig.parameterValueType

        const req = SIMULATE_SAVE_CONFIG_ERROR ?
            Promise.reject('SIMULATE_SAVE_CONFIG_ERROR') :
            MCRequests.saveSystemConfig(systemConfig)

        req
            .then(systemConfig => {


                this.props.context.set({
                        systemConfig,
                        systemConfigParameterValue: JSON.parse(systemConfig.parameterValue),
                        toastMessage: {
                            type: 'success',
                            content: 'Configurações salvas com sucesso.',
                        }
                    },
                    () => {
                        const primaryColor = _.get(this.props.context, 'systemConfigParameterValue.primaryColor', '#000')
                        const secondaryColor = _.get(this.props.context, 'systemConfigParameterValue.secondaryColor', '#fff')
                        setPrimaryColor(primaryColor)
                        setSecondaryColor(secondaryColor)
                    })
            })
            .catch(error => {
                this.props.context.logError(error, {changes})
                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Ocorreu um erro ao tentar salvar as configurações da sua central.'
                    }
                })
            })


    }, 600)


    async checkUserAdmin() {
        const permissions = ["ROLE_SYSTEM_MANAGEMENT_EDIT", "ROLE_SYSTEM_MANAGEMENT_ALL_DATA"]
        const search = this.props.location.search
        const queryParams = QueryString.parse(search)
        const token = queryParams.token

        // console.log(queryParams, 'queryParams')

        if (!token) {
            this.props.history.push("/home")
            return
        }
        try {

            const decodeToken = Base64.decode(token)
            const [schema, login, password] = decodeToken.split(":")
            const params = {
                schema,
                login,
                password
            }


            const result = await Request.getInstance().createPostRequest(Endpoints.admin.login, params, {}, true, null)

            const adminPermissions = result.data.person.permissions.filter(
                a => a.permissionGroup != null && a.permissionGroup.code === 1
            )


            // console.log(adminPermissions, 'adminPermissions')


            const hasPermission = adminPermissions.filter(p => permissions.includes(p.id)).length > 0

            if (!hasPermission) {
                this.props.history.push("/home")
                return
            }

        } catch (err) {
            console.log(err)
            this.props.history.push("/home")
        }
    }
   

    render() {

        const {systemConfigParameterValue, title} = this.state

        return (
            <NRTAppContainer {...this.props} showFooter={false}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{`${title} | Admin`}  </title>
                </Helmet>
                <FullWidthContainer>

                    <ContentContainer center padding style={{padding: '2rem', maxWidth: '45rem'}}>
                        <NRTTabContainer activeTabId={this.state.activeTabId}
                                         mountAllTabs
                                         onTabClick={this.handleTabChange}
                                         tabs={[
                                             {
                                                 id: 'configbasica',
                                                 label: 'Configurações básicas',
                                                 content: <MCEadContentCard>
                                                     <TabBasicConfig
                                                         systemConfigParameterValue={systemConfigParameterValue}
                                                         onConfigChange={this.configChanged}
                                                     />
                                                 </MCEadContentCard>
                                             },
                                             {
                                                 id: 'configsecao',
                                                 label: 'Seções',
                                                 content: <MCEadContentCard>
                                                     <TabSectionConfig
                                                         sections={systemConfigParameterValue.sections}
                                                         onSave={(sections) => this.configChanged({sections})}
                                                     />
                                                 </MCEadContentCard>
                                             },
                                             {
                                                 id: 'configslides',
                                                 label: 'Banner',
                                                 content: <MCEadContentCard>
                                                     <TabBannersConfig
                                                         banners={systemConfigParameterValue.banners}
                                                         s3ParentType={'Configuracao/minhacentral/banner'}
                                                         onSave={(banners) => this.configChanged({banners})}
                                                         schema={this.props.context.credentials.schema}
                                                     />
                                                 </MCEadContentCard>
                                             },

                                         ]}
                        />


                        {/*<NRTButton onClick={this.saveSystemConfig}>*/}
                        {/*Salvar alterações*/}
                        {/*</NRTButton>*/}


                    </ContentContainer>


                </FullWidthContainer>


            </NRTAppContainer>
        )
    }


}


AdminPage.propTypes = {
    context: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
}

AdminPage.defaultProps = {}

export default AdminPage




// WEBPACK FOOTER //
// ./src/_pages/Admin/index.js